/**
 * @Description 机会点详情-新增跟进弹窗
 */
import { FC } from 'react';
import { Modal } from 'antd';
import dayjs from 'dayjs';
import V2Form from '@/common/components/Form/V2Form';
import V2FormDatePicker from '@/common/components/Form/V2FormDatePicker/V2FormDatePicker';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';
import V2FormTextArea from '@/common/components/Form/V2FormTextArea/V2FormTextArea';
import V2FormUpload from '@/common/components/Form/V2FormUpload/V2FormUpload';

interface CreateFollowRecordModalProps {
  form: any;
  open: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

/** 新增机会点跟进记录弹窗。 */
const CreateFollowRecordModal: FC<CreateFollowRecordModalProps> = ({
  form,
  open,
  onCancel,
  onSubmit,
}) => {
  return (
    <Modal
      title='新增跟进'
      open={open}
      width={520}
      forceRender
      onOk={onSubmit}
      onCancel={onCancel}
    >
      <V2Form form={form}>
        <V2FormInput
          required
          label='跟进标题'
          name='name'
          maxLength={50}
        />
        <V2FormDatePicker
          required
          label='跟进时间'
          name='communicateAt'
          config={{ format: 'YYYY-MM-DD' }}
          formItemConfig={{
            getValueFromEvent: (...[, dateString]) => dateString,
            getValueProps: (value) => ({ value: value ? dayjs(value, 'YYYY-MM-DD') : undefined }),
          }}
        />
        <V2FormTextArea
          required
          label='跟进内容'
          name='content'
          maxLength={200}
          config={{ showCount: true }}
        />
        <V2FormUpload
          label='跟进上传凭证'
          name='fileList'
          uploadType='image'
          config={{
            maxCount: 3,
            size: 100,
            fileType: ['png', 'jpg', 'jpeg', 'bmp', 'webp'],
          }}
          formItemConfig={{
            help: '支持 png / jpg / jpeg / bmp / webp 格式的文件，最多3个，不超过100MB',
          }}
          tipConfig={{ tooltipIconShow: false }}
          promptFileAllSuccess
        />
      </V2Form>
    </Modal>
  );
};

export default CreateFollowRecordModal;
